<template>
  <path
    fill="currentColor"
    d="M4.34082 16.3492V3.65086C4.34082 2.63958 5.47918 2.04689 6.30765 2.62682L15.3779 8.976C16.0888 9.47362 16.0888 10.5264 15.3779 11.0241L6.30765 17.3733C5.47918 17.9532 4.34082 17.3605 4.34082 16.3492Z" />
</template>
